<template>
  <div
    class="header-image"
    :class="image.src ? 'header-image--has-image' : 'header-image--no-image'"
  >
    <div v-if="logo" class="header-image-logo">
      <img :src="logo" alt="" />
    </div>
    <picture
      v-if="image.src"
      class="header-image-picture"
      :style="`padding-bottom: ${(image.ratio || 1080 / 1920) * 100}%;`"
    >
      <img :src="image.src" class="header-image-image" :srcset="image.srcSet" />
    </picture>
  </div>
</template>

<script>
export default {
  name: 'HeaderImage',
  props: {
    image: {
      type: Object,
      required: true,
    },
    logo: {
      type: String,
      default: '',
    },
  },
}
</script>

<style scoped>
.header-image {
  display: block;
  position: relative;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  max-width: 1660px;
  max-height: 750px;
  overflow: hidden;
}

.header-image-picture {
  display: block;
  position: relative;
  width: 100%;
  min-height: 200px;
}

.header-image-image {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.header-image-logo {
  position: absolute;
  top: 15px;
  z-index: 1;

  img {
    height: 100%;
  }
}

.header-image--no-image {
  min-height: auto;
  padding-top: 50px;
  overflow: visible;

  .header-image-logo {
    top: 45px;
    right: 0;
    height: 80px;

    img {
      float: right;
    }
  }
}

.header-image--has-image .header-image-logo {
  margin: 35px;
  height: 175px;
}

@media (max-width: 1660px) {
  .header-image--no-image .header-image-logo {
    right: 30px;
  }
}

@media (max-width: 1200px) {
  .header-image--has-image .header-image-logo {
    height: 142px;
  }
}

@media (max-width: 860px) {
  .header-image--has-image .header-image-logo {
    height: 89px;
    margin: 15px 20px;
  }

  .header-image--no-image {
    padding-top: 30px;

    .header-image-logo {
      top: 30px;
      height: 61px;
      right: 10px;
    }
  }
}

@media (max-width: 490px) {
  .header-image--has-image .header-image-logo {
    height: 37px;
    margin: 0;
    left: 8px;
  }

  .header-image--no-image {
    padding-top: 15px;

    .header-image-logo {
      height: 29px;
      top: 15px;
    }
  }
}
</style>
